/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Text, Stack, TextLink } from "@chaser/components";
import { useHistory, useRouteMatch } from "react-router";
import ActiveSubscription from "./ActiveSubscription/index";
import LoadingMessage from "../../../../components/LoadingMessage";
import SecondaryTabs from "../../../../components/SecondaryTabs";
import useSubscription from "../../../../hooks/useSubscription";
import Addons from "../Addons";

const SummaryTab = ({ subscription }) => {
  return (
    <Stack>
      <ActiveSubscription subscription={subscription} />
      <Text color="Mid Neutral 1">
        To see all of your subscriptions please visit your account. For more
        information about Chaser subscriptions please check our{" "}
        <TextLink
          as="a"
          href="https://help.chaserhq.com/subscribing-to-a-plan"
          target="_blank"
          rel="noopener noreferrer"
          monochrome
        >
          Help Centre
        </TextLink>{" "}
        or email{" "}
        <TextLink
          as="a"
          href="mailto:support@chaserhq.com"
          target="_blank"
          rel="noopener noreferrer"
          monochrome
        >
          support@chaserhq.com.
        </TextLink>
      </Text>
    </Stack>
  );
};

const Subscriptions = ({ hidePlansAddonsTab, users }) => {
  const history = useHistory();
  const match = useRouteMatch("/settings/subscription/:subTab");

  const { loading, subscription } = useSubscription();

  const tabs = [
    { path: "summary", title: "Summary" },
    {
      path: "addons",
      title: "Plans & add-ons",
      hidden: hidePlansAddonsTab,
    },
  ];

  const activePath = match?.params?.subTab || "summary";
  const isActiveTabVisible = tabs.some(
    (tab) => tab.path === activePath && !tab.hidden,
  );
  const selectedPath = isActiveTabVisible ? activePath : "summary";

  useEffect(() => {
    if (!isActiveTabVisible) {
      history.replace("/settings/subscription/summary");
    }
  }, [history, isActiveTabVisible]);

  if (loading) return <LoadingMessage />;

  return (
    <Stack gap={0}>
      <SecondaryTabs
        tabs={tabs.map((tab) => ({
          id: tab.path,
          label: tab.title,
          hidden: tab.hidden,
        }))}
        activeId={selectedPath}
        onSelect={(path) => history.push(`/settings/subscription/${path}`)}
        ariaLabel="Subscription sections"
      />

      {selectedPath === "summary" && <SummaryTab subscription={subscription} />}

      {selectedPath === "addons" && !hidePlansAddonsTab && (
        <Addons users={users} />
      )}
    </Stack>
  );
};

export default Subscriptions;
